import { RefObject } from "react";
import { LocalVideoTrack, VideoTrack } from "twilio-video";
import { useRoom } from "../../hooks/useRoom";
import FocusIndicator from "../FocusIndicator/FocusIndicator";
import VideoInfo from "../VideoInfo/VideoInfo";
import { ScreenShareVideo, VideoWrapper } from "./Participant.styles";

const SharedScreenWrapper = VideoWrapper;

interface ISharedScreenProps {
  remoteSharing: boolean;
  screenSharingRef: RefObject<HTMLVideoElement>;
  isLocalParticipant: boolean;
  screenTrack?: VideoTrack;
  localScreenTrack?: LocalVideoTrack;
  participantName?: string;
}

const SharedScreen = ({
  remoteSharing,
  screenSharingRef,
  isLocalParticipant,
  screenTrack,
  localScreenTrack,
  participantName
}: ISharedScreenProps) => {
  const { handleChangeFocused, currentFocused } = useRoom();

  // Focar na tela compartilhada
  const handleShareScreenFocused = () => {
    if (isLocalParticipant) {
      if (localScreenTrack) {
        handleChangeFocused("screen", localScreenTrack);
      }
    } else if (screenTrack) {
      handleChangeFocused("screen", screenTrack);
    }
  };

  return (
    <SharedScreenWrapper hidden={currentFocused === "screen" || !remoteSharing}>
      <ScreenShareVideo ref={screenSharingRef} playsInline autoPlay muted />
      <FocusIndicator
        show={true}
        handleChangeFocused={handleShareScreenFocused}
      />
      <VideoInfo
        name={
          isLocalParticipant
            ? "Sua tela"
            : participantName
              ? `Tela de ${participantName}`
              : "Tela compartilhada"
        }
        videoType="screen"
        isAudioOff={false}
      />
    </SharedScreenWrapper>
  );
};

export default SharedScreen;
